// THIS FILE IS AUTO GENERATED! Local values are for development only.
export const version = {
  hash: '06944ba27cfcf3c41706e1616240e10cc2f64103',
  hashShort: '06944ba'
};
